var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "7", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.6673 8.91667C13.6673 9.83583 12.9198 10.5833 12.0007 10.5833C11.0815 10.5833 10.334 9.83583 10.334 8.91667C10.334 7.9975 11.0815 7.25 12.0007 7.25C12.9198 7.25 13.6673 7.9975 13.6673 8.91667ZM14.9173 14.3333C14.9173 14.5633 14.7311 14.75 14.5007 14.75H9.50065C9.27023 14.75 9.08398 14.5633 9.08398 14.3333C9.08398 12.725 10.3927 11.4167 12.0007 11.4167C13.6086 11.4167 14.9173 12.725 14.9173 14.3333Z",
          fill: "#231F20"
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId0,
            maskUnits: "userSpaceOnUse",
            x: "9",
            y: "7",
            width: "6",
            height: "8"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M13.6673 8.91667C13.6673 9.83583 12.9198 10.5833 12.0007 10.5833C11.0815 10.5833 10.334 9.83583 10.334 8.91667C10.334 7.9975 11.0815 7.25 12.0007 7.25C12.9198 7.25 13.6673 7.9975 13.6673 8.91667ZM14.9173 14.3333C14.9173 14.5633 14.7311 14.75 14.5007 14.75H9.50065C9.27023 14.75 9.08398 14.5633 9.08398 14.3333C9.08398 12.725 10.3927 11.4167 12.0007 11.4167C13.6086 11.4167 14.9173 12.725 14.9173 14.3333Z",
              fill: _vm.insideColor
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId0 + ")" } }, [
        _c("rect", {
          attrs: {
            x: "7",
            y: "6",
            width: "10",
            height: "10",
            fill: _vm.insideColor
          }
        })
      ]),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M10 10.75C10 11.3015 9.5515 11.75 9 11.75C8.4485 11.75 8 11.3015 8 10.75C8 10.1985 8.4485 9.75 9 9.75C9.5515 9.75 10 10.1985 10 10.75ZM10.75 14C10.75 14.138 10.6382 14.25 10.5 14.25H7.5C7.36175 14.25 7.25 14.138 7.25 14C7.25 13.035 8.03525 12.25 9 12.25C9.96475 12.25 10.75 13.035 10.75 14Z",
          fill: "#231F20"
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId1,
            maskUnits: "userSpaceOnUse",
            x: "7",
            y: "9",
            width: "4",
            height: "6"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M10 10.75C10 11.3015 9.5515 11.75 9 11.75C8.4485 11.75 8 11.3015 8 10.75C8 10.1985 8.4485 9.75 9 9.75C9.5515 9.75 10 10.1985 10 10.75ZM10.75 14C10.75 14.138 10.6382 14.25 10.5 14.25H7.5C7.36175 14.25 7.25 14.138 7.25 14C7.25 13.035 8.03525 12.25 9 12.25C9.96475 12.25 10.75 13.035 10.75 14Z",
              fill: _vm.insideColor
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId1 + ")" } }, [
        _c("rect", {
          attrs: {
            x: "6",
            y: "9",
            width: "6",
            height: "6",
            fill: _vm.insideColor
          }
        })
      ]),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16 10.75C16 11.3015 15.5515 11.75 15 11.75C14.4485 11.75 14 11.3015 14 10.75C14 10.1985 14.4485 9.75 15 9.75C15.5515 9.75 16 10.1985 16 10.75ZM16.75 14C16.75 14.138 16.6382 14.25 16.5 14.25H13.5C13.3618 14.25 13.25 14.138 13.25 14C13.25 13.035 14.0353 12.25 15 12.25C15.9648 12.25 16.75 13.035 16.75 14Z",
          fill: "#231F20"
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId2,
            maskUnits: "userSpaceOnUse",
            x: "13",
            y: "9",
            width: "4",
            height: "6"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M16 10.75C16 11.3015 15.5515 11.75 15 11.75C14.4485 11.75 14 11.3015 14 10.75C14 10.1985 14.4485 9.75 15 9.75C15.5515 9.75 16 10.1985 16 10.75ZM16.75 14C16.75 14.138 16.6382 14.25 16.5 14.25H13.5C13.3618 14.25 13.25 14.138 13.25 14C13.25 13.035 14.0353 12.25 15 12.25C15.9648 12.25 16.75 13.035 16.75 14Z",
              fill: _vm.insideColor
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId2 + ")" } }, [
        _c("rect", {
          attrs: {
            x: "12",
            y: "9",
            width: "6",
            height: "6",
            fill: _vm.insideColor
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }